export default __webpack_public_path__ + "static/media/misc-closetA-1920w.80617011.png";